import { isTruthy } from "@dashboard/library";
import {
  GetTagsAndNotesQuery,
  GetTagsAndNotesQueryVariables,
} from "@/graphql/generated/graphql";
import { GetTagsAndNotes } from "@/graphql/queries/GetTagsAndNotes";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { useBaseStore } from "@/store/store";
import { UseGetTagsAndNotesArgs } from "./useGetTagsAndNotes.decl";

export function useGetTagsAndNotes({ callId }: UseGetTagsAndNotesArgs) {
  const setActiveTags = useBaseStore((store) => store.setActiveTags);
  const { data, loading } = useQueryWrapper<
    GetTagsAndNotesQuery,
    GetTagsAndNotesQueryVariables
  >(GetTagsAndNotes, {
    variables: {
      callId,
    },
    onCompleted: (data) => {
      setActiveTags((data.getTagsAndNotes?.tags ?? []).filter(isTruthy));
    },
  });

  return {
    loading,
    // `tags`/`notes` are nullable on the resolved payload (see the `?? []` guard in
    // onCompleted above), so optional-chain the terminal `.filter` too - a partial
    // response with a null field must not crash the page. [CI-6183]
    tags: data?.getTagsAndNotes?.tags?.filter(isTruthy) ?? [],
    notes: data?.getTagsAndNotes?.notes?.filter(isTruthy) ?? [],
  };
}
